import styled from 'styled-components';
import { Card } from 'react-rainbow-components';

export default styled(Card)`
    box-shadow: 0px 4px 18px 0px rgba(75, 70, 92, 0.10)!important;
    border-radius: 1.5rem;
    border: none;
`;
